export const contactLinkGroup = {
  email: {
    text: 'team@policygenius.com',
    href: 'mailto:team@policygenius.com',
  },
  call: {
    text: '1-855-695-2255',
    href: 'tel:1-855-695-2255',
  },
};

export const generalLinkGroups = [
  {
    title: 'Company',
    links: [
      {
        text: 'About us',
        href: '/about/',
      },
      {
        text: 'Policygenius reviews',
        href: '/about/reviews/',
      },
      {
        text: 'Careers',
        href: '/careers/',
      },
      {
        text: 'Partnerships',
        href: 'https://visit.policygenius.com/partnerships/',
      },
      {
        text: 'Policygenius Pro',
        href: 'https://pro.policygenius.com/',
      },
    ],
  },
  {
    title: 'Expertise',
    links: [
      {
        text: 'Editorial standards',
        href: '/about/editorial-standards/',
      },
      {
        text: 'Financial Review Council',
        href: '/about/financial-review-council/',
      },
      {
        text: 'Press',
        href: '/about/press/',
      },
    ],
  },
  {
    title: 'News & research',
    links: [
      {
        text: 'News',
        href: '/news/',
      },
      {
        text: 'Research at Policygenius',
        href: '/research/',
      },
      {
        text: 'Life Insurance Price Index',
        href: '/life-insurance/life-insurance-price-index/',
      },
      {
        text: 'Home Insurance Pricing Report',
        href: '/homeowners-insurance/home-insurance-pricing-report-2023/',
      },
    ],
  },
];

export const legalSectionLinks = [
  {
    text: 'Privacy Notice',
    href: '/about/privacy/',
  },
  {
    text: 'Online tracking opt-out guide',
    href: '/about/privacy/#x-online-tracking-opt-out-guide',
  },
  {
    text: 'Accessibility',
    href: '/about/disclosures/#web-accessibility',
  },
  {
    text: 'Terms & conditions',
    href: '/about/terms/',
  },
  {
    text: 'Disclosures',
    href: '/about/disclosures/',
  },
];

export const accordionLinkGroups = [
  {
    title: 'Life',
    links: [
      {
        text: 'Types of life insurance',
        href: '/life-insurance/types-of-life-insurance/',
      },
      {
        text: 'Term vs. whole life insurance',
        href: '/life-insurance/term-vs-whole-life-insurance/',
      },
      {
        text: 'How to buy life insurance',
        href: '/life-insurance/how-to-buy-life-insurance/',
      },
      {
        text: 'How much life insurance do I need?',
        href: '/life-insurance/how-much-life-insurance-do-i-need/',
      },
      {
        text: 'How does life insurance work?',
        href: '/life-insurance/how-does-life-insurance-work/',
      },
    ],
  },
  {
    title: 'Home',
    links: [
      {
        text: 'How to buy homeowners insurance',
        href: '/homeowners-insurance/how-to-buy-homeowners-insurance/',
      },
      {
        text: 'How much homeowners insurance do I need?',
        href: '/homeowners-insurance/how-much-homeowners-insurance-do-i-need/',
      },
      {
        text: 'Why did my homeowners insurance go up?',
        href: '/homeowners-insurance/why-did-my-homeowners-insurance-rates-go-up/',
      },
    ],
  },
  {
    title: 'Auto',
    links: [
      {
        text: 'How to buy car insurance',
        href: '/auto-insurance/how-to-buy-car-insurance/',
      },
      {
        text: 'How much car insurance do I need?',
        href: '/auto-insurance/how-much-car-insurance-do-you-need/',
      },
    ],
  },
  {
    title: 'Disability',
    links: [
      {
        text: 'How does long-term disability insurance work?',
        href: '/disability-insurance/how-does-long-term-disability-insurance-work/',
      },
      {
        text: 'Types of disability insurance',
        href: '/disability-insurance/types-of-disability-insurance/',
      },
      {
        text: 'How to get disability insurance',
        href: '/disability-insurance/how-to-get-disability-insurance/',
      },
      {
        text: 'Is long-term disability insurance worth it?',
        href: '/disability-insurance/is-long-term-disability-insurance-worth-it/',
      },
    ],
  },
  {
    title: 'Renters',
    links: [
      {
        text: 'Renters insurance',
        href: '/renters-insurance/',
      },
      {
        text: 'Bundling renters & auto insurance',
        href: '/auto-insurance/car-and-renters-insurance-bundling-discounts/',
      },
      {
        text: 'Renters insurance calculator',
        href: '/renters-insurance/renters-insurance-calculator/',
      },
      {
        text: 'Renters insurance cost',
        href: '/renters-insurance/learn/how-much-is-renters-insurance/',
      },
      {
        text: `Best renters insurance companies of ${new Date().getFullYear()}`,
        href: '/renters-insurance/learn/the-best-renters-insurance-companies/',
      },
      {
        text: 'Renters insurance company reviews',
        href: '/renters-insurance/reviews/',
      },
      {
        text: 'What does renters insurance cover?',
        href: '/renters-insurance/learn/what-does-renters-insurance-cover/',
      },
    ],
  },
  {
    title: 'Other insurance',
    links: [
      {
        text: 'Annuities',
        href: '/annuities/',
      },
      {
        text: 'Health insurance',
        href: '/health-insurance/',
      },
      {
        text: 'Long-term care insurance',
        href: '/long-term-care-insurance/',
      },
      {
        text: 'Pet insurance',
        href: '/pet-insurance/',
      },
    ],
  },
];
